export const RANK_TIERS = [
  { name: 'Elite', emoji: '🔴', minElo: 1400, color: '#ef4444', bgColor: 'rgba(239, 68, 68, 0.15)',
    gradient: ['#dc2626', '#f87171'], border: '#fca5a5' },
  { name: 'Diamond', emoji: '🟣', minElo: 1250, color: '#a855f7', bgColor: 'rgba(168, 85, 247, 0.15)',
    gradient: ['#7c3aed', '#c084fc'], border: '#d8b4fe' },
  { name: 'Platinum', emoji: '🔵', minElo: 1150, color: '#3b82f6', bgColor: 'rgba(59, 130, 246, 0.15)',
    gradient: ['#2563eb', '#60a5fa'], border: '#93c5fd' },
  { name: 'Gold', emoji: '🟡', minElo: 1050, color: '#fbbf24', bgColor: 'rgba(251, 191, 36, 0.15)',
    gradient: ['#d97706', '#fcd34d'], border: '#fde68a' },
  { name: 'Silver', emoji: '⚪', minElo: 950, color: '#9ca3af', bgColor: 'rgba(156, 163, 175, 0.15)',
    gradient: ['#6b7280', '#d1d5db'], border: '#e5e7eb' },
  { name: 'Bronze', emoji: '🟤', minElo: 0, color: '#a16207', bgColor: 'rgba(161, 98, 7, 0.15)',
    gradient: ['#78350f', '#ca8a04'], border: '#d97706' },
];

export const getRankTier = (elo) => {
  for (const tier of RANK_TIERS) {
    if (elo >= tier.minElo) return tier;
  }
  return RANK_TIERS[RANK_TIERS.length - 1];
};
